import React from 'react';
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import './App.css';
import Header from './pages/Header.js';
import Footer from './pages/Footer.js';
import WhatsAppFloatingButton from './components/MessageIcon.js';
import HomePage from './pages/HomePage.js';
import HousePlanPage from './pages/Houseplan.js';
import ServicesPage from './pages/ServicesPage.js';
import ProjectsPage from './pages/ProjectsPage.js';
import ElevationPage from './pages/ElevationPage.js';
import DesignPage from './pages/DesignPage.js';
import SurveyPage from './pages/Survey.js';
import Pricing from './pages/Pricing.js';
import Blog from './pages/Blog.js';
import OurStory from './pages/OurStory.js';
import Careers from './pages/Careers.js';
import ReadyHouseDesigns from './pages/ReadyHouseDesigns.js';
import FloorPlan from './pages/FloorPlan.js';
import HouseConstruction from './pages/HouseConstruction.js';
import HomeInteriorDesign from './pages/HomeInteriorDesign.js';
import OfficeInteriorDesign from './pages/OfficeInteriorDesign.js';
import DesignIdeas from './pages/DesignIdeas.js';
import TwoDPlansElevations from './pages/TwoDPlansElevations.js';
import ThreeDArchitecturalModeling from './pages/ThreeDArchitecturalModeling.js';
import ThreeDRenderingVisualization from './pages/ThreeDRenderingVisualization.js';
import BuildingInformationModeling from './pages/BuildingInformationModeling.js';
import VirtualToursWalkthroughs from './pages/VirtualToursWalkthroughs.js';
import ThreeDInteriorDesign from './pages/ThreeDInteriorDesign.js';
import ResidentialConstruction from './pages/ResidentialConstruction.js';
import CommercialConstruction from './pages/CommercialConstruction.js';
import Renovations from './pages/Renovations.js';
import FootingConstruction from './pages/FootingConstruction.js';
import DailyChecklistsInspections from './components/DailyChecklistsInspections.js';
import ProgressReportsDocumentation from './components/ProgressReportsDocumentation.js';
import CommunicationCollaboration from './components/CommunicationCollaboration.js';
import SafetyProtocolsCompliance from './components/SafetyProtocolsCompliance.js';
import MaterialManagementInventory from './components/MaterialManagementInventory.js';
import QualityAssuranceControl from './components/QualityAssuranceControl.js';
import ModernFamilyHome from './components/ModernHome';
import CommercialOfficeBuilding from "./components/CommercialOfficeBuilding";
import RenovatedHistoricalHouse from "./components/RenovatedHistoricalHouse";
import LuxuryApartmentComplex from "./components/LuxuryApartmentComplex";
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import CookiePolicy from './components/CookiePolicy';
import Seo from './components/Seo';
import ElevationBlogPage from './blogpages/ElevationBlogPage.js';
import CostEffectiveInteriorDesignPage from './blogpages/CostEffectiveInteriorDesignPage.js';
import ModernHomeDesignPage from './blogpages/ModernHomeDesignPage.js';
import SmartKitchenDesignPage from './blogpages/SmartKitchenDesignPage.js';
import SustainableConstructionPatnaPage from './blogpages/SustainableConstructionPatnaPage.js';
import BlueprintSymbolsGuidePage from './blogpages/BlueprintSymbolsGuidePage.js';
import GharBananeKiLagatBiharPage from './blogpages/GharBananeKiLagatBiharPage.js';
import ChoteGharonKeLiyeBehtareenDesignPage from './blogpages/ChoteGharonKeLiyeBehtareenDesignPage.js';
import ApniNayiGharKiYojanaKaiseBanayePage from './blogpages/ApniNayiGharKiYojanaKaiseBanayePage';
import VastuShastraKeAnusarGharKaDesignPage from './blogpages/VastuShastraKeAnusarGharKaDesignPage';
import { MazbootGharBananeKeLiyeMahatvapurnaBateinPage, GharKeNaksheKoKaiseSamjhePage } from './blogpages/HindiBlogPages';
import CozyFamilyHomeDetails from './components/CozyFamilyHomeDetails.js';
import ModernVillaDetails from './components/ModernVillaDetails.js';
import ThreeDInteriorDesignProcessPage from './blogpages/ThreeDInteriorDesignProcessPage.js';
import SouthFacingHousePlan from './components/SouthFacingHousePlan.js';
import HousePlan20x30 from './components/HousePlan20x30.js';
import HousePlan20x40 from './components/HousePlan20x40.js';
import HousePlan30x40 from './components/HousePlan30x40.js';
import HousePlan30x50 from './components/HousePlan30x50.js';
import HousePlan40x60 from './components/HousePlan40x60.js';
import PageOne2BHK from './floorpages/PageOne2BHK';
import PageTwo3BHK from './floorpages/PageTwo3BHK';
import PageThree4BHK from './floorpages/PageThree4BHK';
import PageShopsBihar from './floorpages/PageShopsBihar';
import PageOfficesBihar from './floorpages/PageOfficesBihar';
import PageOtherBuildingsBihar from './floorpages/PageOtherBuildingsBihar';
import PageHomeNaksha3D from './floorpages/PageHomeNaksha3D';
import PageVillageHomeNaksha from './floorpages/PageVillageHomeNaksha';
import PageSimpleHomeNaksha from './floorpages/PageSimpleHomeNaksha';
import PageVastuHomeNaksha from './floorpages/PageVastuHomeNaksha';
import HousePlanImportancePage from './blogpages/HousePlanImportancePage.js';
import FreeHousePlanPage from './blogpages/FreeHousePlanPage.js'
import NotFoundPage from './pages/NotFoundPage.js';
import MapPass from './floorpages/MapPass.js';
import NewHomeConstructionChecklistPage from './blogpages/NewHomeConstructionChecklistPage.js';
import AvoidingTop5MistakesPage from './blogpages/AvoidingTop5MistakesPage.js';
import SmallOfficeDesignPage from './blogpages/SmallOfficeSpace.js';
import VastuCompliantHouse from './blogpages/Vastu.js';
import VastuKitchenTips from './blogpages/VastuKitchenTips.js';
import VastuMainEntrance from './blogpages/VastuMainEntrance.js';
import BihariArchitectureVastu from './blogpages/BihariArchitectureVastu.js';
import MultiStoreyHousePlans from './blogpages/MultiStoreyHousePlans.js';
import DesignInspirationBlog from './blogpages/DesignInspirationBlog.js';
import ConstructionChallengesPage from './blogpages/ConstructionChallengesPage.js';
import KitchenInteriorDesignPage from './blogpages/KitchenInteriorDesignPage.js';
function App() {
   useEffect(() => {
           const tagManagerArgs = {
               gtmId: 'GTM-NX4NGRXD'
           };
           TagManager.initialize(tagManagerArgs);
       }, []);
  return (
    <>
    <Router>
      <div>
        <Header />
         <WhatsAppFloatingButton
                phoneNumber="918828531570" 
                message="I'm interested in your services, could you tell me more?"
                scrollThreshold={100}
                initialDelay={7000} // Button appears after 7 seconds AND scrolling 300px
                showTextOnHover={true}
                hoverText="Need Help?"
                dotContent="!" // Or "1", "NEW", or empty
            />
        <Routes>
        <Route
            path="/"
            element={
              <>
                <Seo
                  title="Housekaar Construction Company - Architectural & Interior Design in Patna"
                  description="Housekaar Construction Company provides expert architectural design, interior design, and construction services in Patna, Bihar. We specialize in creating beautiful and functional homes. Contact us for your dream home."
                  keywords="house construction Patna,interior design Patna,architectural design Patna,construction company Bihar,home naksha Bihar,हौसेकर,2d house plan Patna,home builders Bihar,residential construction Patna,commercial construction Bihar,office interior design Patna,3d interior design Bihar, exterior design Bihar, ghar ka naksha Patna"
                  location="Patna, Bihar"
                  alternateLocations = "Bihar"
                  imageUrl="https://housekaar.com/static/media/dream_home.17aa0cc793fede9fc07f.avif" // Replace with a relevant image URL
                  article={false} // It's not an article, but a website page
                  publishedTime={null} // Not applicable for home page
                  modifiedTime={null} // Not applicable for home page
                />
                <HomePage />
              </>
            }
          />
        <Route
  path="/house-plans"
  element={
   <>
    <Seo
     title="House Plans & Architectural Designs in Patna, Bihar | Housekaar"
     description="Explore a wide range of house plans and architectural designs in Patna, Bihar. Find the perfect plan for your dream home with Housekaar's expert services."
     keywords="
     floor plan house design,u shaped house floor plan,floorplan in autocad,floorplan layout,
     house plans Patna, architectural designs Patna, floor plan Patna, home naksha Patna, home plans Patna, building plans Patna, Patna, Bihar, Housekaar, residential plans, custom house plans, house plan, house plan design, 2bhk house plan, 3bhk house plan, 3 bhk house plan, house plan drawing, 1000 square feet house plan, 30*40 house plan, 25*50 house plan, 3 bedroom house plan, 2 bhk house plan in village, 20*50 house plan, low cost 2 bedroom house plan, 30*50 house plan, east facing house plan, 1 bhk house plan in village, north facing house plan, 4 bhk house plan, 4bhk house plan"
     location="Patna, Bihar"
     imageUrl="https://housekaar.com/static/media/exterior.89786aca96eade270438.avif" // Replace with a relevant image URL
     article={false}
    />
    <HousePlanPage />
   </>
  }
 />
          <Route
            path="/services"
            element={
              <>
                <Seo
                  title="Construction & Design Services in Patna | Housekaar"
                  description="Discover our comprehensive construction and design services in Patna, Bihar. From architectural design to interior solutions, Housekaar delivers quality and excellence."
                  keywords="construction services, architectural services, interior design, home construction, building services, Patna, Bihar, Housekaar, residential services, commercial services"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/pexels-expect-best-79873-323780.081bdeb6bfdddf410934.avif" // Replace with a relevant image URL
                  article={false}
                />
                <ServicesPage />
              </>
            }
          />
          <Route
            path="/projects"
            element={
              <>
                <Seo
                  title="Completed Construction Projects in Patna | Housekaar"
                  description="View our portfolio of completed construction projects in Patna, Bihar. See how Housekaar turns visions into reality with exceptional craftsmanship and design."
                  keywords="construction projects, completed projects, building projects, home construction, Patna, Bihar, Housekaar, residential projects, commercial projects, project portfolio"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/elevation_img_26.3f50f818a9a3865a5e40.avif" // Replace with a relevant image URL
                  article={false}
                />
                <ProjectsPage />
              </>
            }
          />
          <Route
  path="/elevation"
  element={
   <>
    <Seo
     title="Modern House Elevation Designs in Patna, Bihar | Housekaar"
     description="Explore a wide range of stunning and modern house elevation designs in Patna, Bihar. Housekaar offers innovative exterior solutions for your dream home."
     keywords="
     elevation design,
elevation,
front elevation design,
design house elevation,
home design front elevation,
house elevation front design,
elevation front,
elevation of the building,
elevation building elevation,
front elevation of home,
house elevation front,
elevation in house,
elevation for home,
elevation meaning in hindi,
elevation with tiles,
elevation meaning,
elevation tiles,
single floor elevation,
front elevation design double floor,
house elevation design single floor,
elevation ground floor,
elevation tiles design,
elevation lights,
elevation angle,
one floor house elevation,
single floor elevation design,
house elevation single floor,
elevation colour combination,
elevation designs single floor,
elevation colour,
elevation photos,
first floor elevation,
front elevation of a building,
elevation design for 2 floor building,
colour combination for front elevation,
elevation 3d,
g 1 elevation designs,
elevation 3d design,
elevation design photos,
elevation of building images,
elevation pictures,
elevation design for home,
building elevation photos,
elevation pics,
glass elevation design,
house front elevation designs for single floor,
elevation flower design,
grey colour elevation,
simple ground floor elevation,
modern ground floor elevation,
housing elevation photos
front elevation designs for single floor
house elevation colour
modern 2 floor front elevation
front elevation of house single floor
house design elevation photos
elevation designs for 1 floors building
ground floor front elevation

     house elevation Patna, elevation designs Patna, home exterior Patna, building facade Patna, Patna, Bihar, Housekaar, residential elevation, modern elevation, architectural elevation, 3 floor house elevation designs andhra, house elevation design single floor, small house elevation colours, house elevation design for 2 floors, residential building 3 floor house elevation designs, 25*40 house elevation, simple duplex house elevation, single east facing house elevation ground floor, single floor house elevation design, house elevation colours, small house elevation designs, house elevation designs, single floor house elevation, east facing house elevation double floor, 25*40 house elevation double floor, small house elevation design"
     location="Patna, Bihar"
     imageUrl="https://housekaar.com/static/media/13-best-tools-cover.165d54a1d7781b68d927.avif" // Replace with a relevant image URL
     article={false}
    />
    <ElevationPage />
   </>
  }
 />
          <Route
  path="/designpage"
  element={
   <>
    <Seo
     title="Our Service Process in Patna | Housekaar"
     description="Learn about Housekaar's streamlined service process in Patna. We ensure a clear and efficient journey for your architectural design, house construction, and interior design needs."
     keywords="service process Patna, how we work Patna, Housekaar process, architectural design process, house construction, process, interior design process, Patna, Bihar"
     location="Patna, Bihar"
     imageUrl="https://housekaar.com/static/media/pexels-itsterrymag-2635038.ff8550c8056c95613df3.avif"
     article={false}
    />
    <DesignPage />
   </>
  }
 />
  <Route
  path="/survey"
  element={
    <>
      <Seo
        title="Land Survey Services in Patna | Housekaar Construction Company"
        description="Get accurate and reliable land survey services from Housekaar Construction Company in Patna. We provide precise measurements and detailed reports for all your land surveying needs."
        keywords="land survey, land surveying, property survey, land measurement, boundary survey, topographic survey, site survey, construction survey, Patna, Bihar, Housekaar, construction company"
        location="Patna, Bihar"
        imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif"
        article={false}
      />
      <SurveyPage />
    </>
  }
/>
          <Route
            path="/pricing"
            element={
              <>
                <Seo
                  title="Pricing for Construction & Design Services in Patna | Housekaar"
                  description="View our transparent pricing for architectural design, interior design, and construction services in Patna. Get a free quote for your project with Housekaar."
                  keywords="construction pricing, design pricing, architectural cost, interior design cost,2bhk interior design cost Patna, 2 bhk interior design cost Patna, interior design cost for 2 bhk Patna, home interior design cost Patna, residential interior design cost Patna, interior design cost Patna, Patna, Bihar, Housekaar, building costs, home construction pricing,home interior design cost Patna, residential interior design cost Patna, house interior design cost Patna, cost of interior design for home Patna, interior design pricing Patna,interior design cost per square foot Patna, interior design rate per sq ft Patna, home interior design cost per sq ft Patna, office interior design cost per sq ft Patna, interior design pricing Patna,1 bhk interior design cost Patna, 1bhk interior design cost Patna, 1 bedroom interior design cost Patna, small apartment interior design cost Patna,3bhk interior design cost Patna, 3 bhk interior design cost Patna, interior design cost for 3 bhk Patna, home interior design cost Patna, residential interior design cost Patna, interior design cost Patna"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/up_bedromm.b64e5e4397981949276c.avif
                  "
                  article={false}
                />
                <Pricing />
              </>
            }
          />
          <Route
            path="/blog"
            element={
              <>
                <Seo
                  title="Construction & Design Blog | Housekaar Patna"
                  description="Read our blog for the latest insights, tips, and trends in construction and design in Patna. Stay informed with Housekaar's expert advice."
                  keywords="construction blog, design blog, home building tips, architectural insights, Patna, Bihar, Housekaar, building trends, interior design tips"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/blueprint-4056027_1920.95e09d3eb1171a69467f.avif"
                  article={false}
                />
                <Blog />
              </>
            }
          />
          <Route
            path="/our-story"
            element={
              <>
                <Seo
                  title="Our Story | Housekaar Construction Company in Patna"
                  description="Learn about the journey and values of Housekaar Construction Company in Patna. Discover our commitment to quality and customer satisfaction."
                  keywords="our story, company history, about us, building company, Patna, Bihar, Housekaar, construction company values, company mission"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <OurStory />
              </>
            }
          />
          <Route
            path="/careers"
            element={
              <>
                <Seo
                  title="Careers at Housekaar Construction in Patna | Join Our Team"
                  description="Explore career opportunities at Housekaar Construction in Patna. Join our team of professionals and build your career in the construction and design industry."
                  keywords="careers, jobs, construction jobs, design jobs, hiring, Patna, Bihar, Housekaar, building careers, architectural jobs"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/housekaar_logo.0438311c1b4ca42e0f48.jpeg"
                  article={false}
                />
                <Careers />
              </>
            }
          />
          <Route
            path="/ready-designs"
            element={
              <>
                <Seo
                  title="Ready House Designs in Patna | Housekaar"
                  description="Browse our collection of ready house designs in Patna. Find pre-designed plans that fit your style and budget with Housekaar's expert solutions."
                  keywords="ready house designs, pre-designed plans, house plans, building designs, Patna, Bihar, Housekaar, residential designs, home plans"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/interior.2298c2e97696f749d6c2.avif"
                  article={false}
                />
                <ReadyHouseDesigns />
              </>
            }
          />
          <Route
  path="/floor-plans"
  element={
   <>
    <Seo
     title="Floor Plans & House Designs | Housekaar Construction in Patna"
     description="View various floor plans and house designs offered by Housekaar Construction in Patna. Find the perfect plan to meet your needs."
     keywords="
     floorplan houses,
floorplan home,
blueprints for small houses,
floorplan generator,
floorplan drawing,
floorplanner,
floorplan for small house,
floorplan design,
floorplan 2 story,
     floor plans, building plans, house plans,2bhk ,3bhk,4bhk,5bhk,6bhk,southfacing, houseplan Patna, Bihar, Housekaar, home plans, architectural plans, floorplan, floorplan design, floorplan ai, floorplan in vlsi, floorplan creator, 2d floorplan, 3d floorplan, floorplan images, office floorplan, floorplan ai generator, house floorplan, floorplan 3d, floorplan image, create a floorplan, floorplan app, floorplan studio, floorplan to 3d model, floorplan with dimensions, houseplan, houseplan ai, houseplan 3d.com, houseplan-3d, houseplan engineering, houseplan maker, houseplan files, 2bhk houseplan, houseplan app, houseplan search, the houseplan shop, houseplan online, 4 bedroom houseplan, houseplan design, best modern high-tech houseplan designs in bihar"
     location="Patna, Bihar"
     imageUrl="https://housekaar.com/static/media/houseplan.bd1201c41404c1ef765f.avif"
     article={false}
    />
    <FloorPlan />
   </>
  }
 />
         <Route
  path="/house-construction"
  element={
   <>
    <Seo
     title="House Construction Services in Patna, Bihar | Housekaar"
     description="Get professional house construction services in Patna and across Bihar with Housekaar. We build your dream homes with quality materials and expert craftsmanship."
     keywords="
     home construction steps,
home construction company,
home construction firm,
new home construction,
home construction cost calculator,
home construction plan,
low cost home construction,
low price home construction,
foundation for home construction,
home construction step by step,
home construction start to finish,
home construction ideas,,
cement home construction,
home construction estimate,
home construction basement,
home construction materials,
india home construction,
home construction cost per square feet,
home construction video,
tiny home construction,
home construction cost per sq ft,
construction home,

new home construction ideas,


custom home construction,
home construction process step by step,
luxury home construction,
new home construction cost,
low budget home construction,
environmentally friendly home construction,
eco friendly home construction,
home construction phases,
home construction under 10 lakhs,
affordable home construction,
what is my one construction,
best home construction companies in india
new home construction plans,
new home construction design,
modern home construction plans,
home under construction,
home construction stages,
home construction near me,
home construction business,
how to start construction of house,
luxury home construction cost,

     house construction , home building, residential construction , building services, Patna, Bihar, Housekaar, home construction services Patna, new home construction Patna, house construction cost calculator Patna, best cement for house construction in Bihar, best steel for house construction in Bihar, labour cost for house construction per sq ft Patna, low cost house construction Patna, step by step house construction Bihar, house construction contractors Patna, house construction design Patna, house construction cost per square feet Patna"
     location="Patna, Bihar"
     imageUrl="https://housekaar.com/static/media/exterior.89786aca96eade270438.avif"
     article={false}
    />
    <HouseConstruction />
   </>
  }
 />
          <Route
  path="/home-interior"
  element={
   <>
    <Seo
     title="Home Interior Design Services in Patna | Housekaar"
     description="Transform your home with our home interior design services in Patna. Housekaar creates stylish and functional spaces that reflect your personal taste."
     keywords="
     interior design,
d interior design,
interior design of house,
interior design homes,
interior design class,
interior design ideas,
interior design of kitchen,
interior design and home decor ideas,
interior design decor ideas,
bed room interior design,
interior designer near me,
interior designers,
interior design of living room,
drawing room interior design ideas,
living area interior design,
interior design tips for living room,
interior design of room,
living room interior design ideas,
household interior design,
interior design for drawing room,
simple bedroom interior design,
luxury interior design for bedroom,
luxury bedroom interior design,
     home interior, residential interior, interior decoration, home styling, home dsgn,interior designer, Patna, Bihar, Housekaar, home interior design ,interior design services,interior designer in patna, home decor, house design, home interior ideas, household designs, home design, design on home, home to design, home dijayan, design interior design, interior and design, interior design interior, interior design a, interior design for home, house design interior design, interior design ideas, house interior design, house design ideas"
     location="Patna, Bihar"
     imageUrl="https://housekaar.com/static/media/living_room_img_2.06de858d13a6c2c72ac4.avif"
     article={false}
    />
    <HomeInteriorDesign />
   </>
  }
 />
 <Route
  path="/office-interior"
  element={
   <>
    <Seo
     title="Office Interior Design in Patna | Housekaar"
     description="Enhance your workspace with our office interior design services in Patna. Housekaar creates productive and inspiring office environments."
     keywords="office interior ,office interior design, commercial interior, office styling, workplace design, Patna, Bihar, Housekaar,interior design, office decor, interior solutions, interior design, design interior design, interior and design, design & interiors"
     location="Patna, Bihar"
     imageUrl="https://housekaar.com/static/media/pexels-pixabay-273671.ac0c053a0e16f3b16753.avif"
     article={false}
    />
    <OfficeInteriorDesign />
   </>
  }
 />
          <Route
            path="/design-ideas"
            element={
              <>
                <Seo
                  title="Design Ideas | Housekaar Construction in Patna"
                  description="Find design ideas for your home or office in Patna. Housekaar provides inspiration and expert advice to help you create your dream space."
                  keywords="design ideas, interior design tips, home decor ideas,home dsgn,office design inspiration, Patna, Bihar, Housekaar, building design ideas, architectural inspiration"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/ideas_img_1.e923cce1a7623a5224d9.avif"
                  article={false}
                />
                <DesignIdeas />
              </>
            }
          />
          <Route
            path="/two-d-plans"
            element={
              <>
                <Seo
                  title="2D Plans Services in Patna | Housekaar"
                  description="Get detailed 2D plans and elevations for your construction projects in Patna. Housekaar provides accurate and professional drawings to bring your vision to life."
                  keywords="2d plans,autocad 2d plans, architectural drawings,house 2d plans, building plans, 2d plans with dimensions,Patna, Bihar, Housekaar, home plans, construction drawings"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <TwoDPlansElevations />
              </>
            }
          />
          <Route
            path="/three-d-architectural-modeling"
            element={
              <>
                <Seo
                  title="3D Architectural Modeling Services in Patna | Housekaar"
                  description="Visualize your architectural designs with our 3D modeling services in Patna. Housekaar brings your projects to life with detailed 3D representations."
                  keywords="3d architectural modeling, building modeling, architectural visualization, Patna, Bihar, Housekaar, 3d design, home modeling"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <ThreeDArchitecturalModeling />
              </>
            }
          />
          <Route
            path="/three-d-rendering-visualization"
            element={
              <>
                <Seo
                  title="3D Rendering & Visualization Services in Patna | Housekaar"
                  description="Get realistic 3D renderings and visualizations for your projects in Patna. Housekaar creates stunning visuals to help you make informed decisions."
                  keywords="3d rendering, architectural visualization, building rendering, Patna, Bihar, Housekaar, 3d visualization, home rendering"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <ThreeDRenderingVisualization />
              </>
            }
          />
          <Route
            path="/building-information-modeling"
            element={
              <>
                <Seo
                  title="Building Information Modeling (BIM) Services in Patna | Housekaar"
                  description="Optimize your construction projects with our BIM services in Patna. Housekaar provides accurate and efficient building information modeling solutions."
                  keywords="building information modeling, BIM services, construction modeling, Patna, Bihar, Housekaar, building design, architectural modeling"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <BuildingInformationModeling />
              </>
            }
          />
          <Route
            path="/virtual-tours-walkthroughs"
            element={
              <>
                <Seo
                  title="Virtual Tours & Walkthroughs in Patna | Housekaar"
                  description="Experience your future spaces with our virtual tours and walkthroughs in Patna. Housekaar provides immersive experiences for your architectural designs."
                  keywords="virtual tours, architectural walkthroughs, 3d tours, Patna, Bihar, Housekaar, building tours, home walkthroughs"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <VirtualToursWalkthroughs />
              </>
            }
          />
          <Route
            path="/three-d-interior-design"
            element={
              <>
                <Seo
                  title="3D Interior Design Services in Patna | Housekaar"
                  description="Visualize your interior spaces with our 3D interior design services in Patna. Housekaar creates realistic and detailed 3D representations of your interiors."
                  keywords="3d interior design, interior visualization, home design, Patna, Bihar, Housekaar, 3d interior, interior modeling"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <ThreeDInteriorDesign />
              </>
            }
          />
          <Route
            path="/residential-construction"
            element={
              <>
                <Seo
                  title="Residential Construction Services in Patna | Housekaar"
                  description="Build your dream home with our residential construction services in Patna. Housekaar delivers quality homes with expert craftsmanship and attention to detail."
                  keywords="residential construction, home building, house construction, Patna, Bihar, Housekaar, home construction services, residential builders"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <ResidentialConstruction />
              </>
            }
          />
          <Route
            path="/commercial-construction"
            element={
              <>
                <Seo
                  title="Commercial Construction Services in Patna | Housekaar"
                  description="Build your business spaces with our commercial construction services in Patna. Housekaar delivers quality commercial buildings tailored to your business needs."
                  keywords="commercial construction, building construction, office construction, Patna, Bihar, Housekaar, commercial builders, construction services"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <CommercialConstruction />
              </>
            }
          />
          <Route
            path="/renovations"
            element={
              <>
                <Seo
                  title="Renovation Services in Patna | Housekaar"
                  description="Transform your existing spaces with our renovation services in Patna. Housekaar provides quality renovations to enhance the functionality and aesthetics of your home or office."
                  keywords="renovation,renovation construction,house renovation,renovation services, home renovation, office renovation ,shop renovation, Patna, Bihar, Housekaar, building renovation, remodeling services"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <Renovations />
              </>
            }
          />
          <Route
            path="/footing-construction"
            element={
              <>
                <Seo
                  title="Footing Construction Services in Patna | Housekaar"
                  description="Ensure a strong foundation with our footing construction services in Patna. Housekaar provides expert footing construction for residential and commercial projects."
                  keywords="footing construction, foundation construction, building footing, Patna, Bihar, Housekaar, construction services, foundation services"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <FootingConstruction />
              </>
            }
          />
          <Route
            path="/daily-checklists-inspections"
            element={
              <>
                <Seo
                  title="Daily Construction Checklists & Inspections in Patna | Housekaar"
                  description="Ensure project quality with our daily checklists and inspections in Patna. Housekaar maintains rigorous standards for every construction phase."
                  keywords="daily checklists, construction inspections, building quality control, Patna, Bihar, Housekaar, construction management, project inspections"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <DailyChecklistsInspections />
              </>
            }
          />
          <Route
            path="/progress-reports-documentation"
            element={
              <>
                <Seo
                  title="Construction Progress Reports & Documentation in Patna | Housekaar"
                  description="Stay informed with detailed progress reports and documentation in Patna. Housekaar ensures transparency and accountability throughout your project."
                  keywords="construction progress reports, project documentation, building reports, Patna, Bihar, Housekaar, project management, construction records"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <ProgressReportsDocumentation />
              </>
            }
          />
          <Route
            path="/communication-collaboration"
            element={
              <>
                <Seo
                  title="Construction Communication & Collaboration in Patna | Housekaar"
                  description="Experience seamless communication and collaboration for your construction projects in Patna. Housekaar fosters teamwork for efficient project delivery."
                  keywords="construction communication, project collaboration, team communication, Patna, Bihar, Housekaar, project management, building coordination"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <CommunicationCollaboration />
              </>
            }
          />
          <Route
            path="/safety-protocols-compliance"
            element={
              <>
                <Seo
                  title="Construction Safety Protocols & Compliance in Patna | Housekaar"
                  description="Ensure safety and compliance with our construction protocols in Patna. Housekaar adheres to strict safety standards for every project."
                  keywords="construction safety, safety protocols, building compliance, Patna, Bihar, Housekaar, project safety, construction regulations"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <SafetyProtocolsCompliance />
              </>
            }
          />
          <Route
            path="/material-management-inventory"
            element={
              <>
                <Seo
                  title="Construction Material Management & Inventory in Patna | Housekaar"
                  description="Efficient material management and inventory control for your construction projects in Patna. Housekaar ensures timely delivery and cost-effectiveness."
                  keywords="construction materials, material management, building inventory, Patna, Bihar, Housekaar, project materials, construction supplies"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <MaterialManagementInventory />
              </>
            }
          />
          <Route
            path="/quality-assurance-control"
            element={
              <>
                <Seo
                  title="Construction Quality Assurance & Control in Patna | Housekaar"
                  description="Guarantee quality construction with our assurance and control services in Patna. Housekaar ensures every project meets the highest standards."
                  keywords="construction quality assurance, quality control, building quality, Patna, Bihar, Housekaar, project quality, construction standards"
                  location="Patna, Bihar"
                  imageUrl="https://housekaar.com/static/media/kitchen_modern_classic.9b526476f59a23445517.avif
                  "
                  article={false}
                />
                <QualityAssuranceControl />
              </>
            }
          />
         <Route path="/modern-home" element={
  <>
   <Seo
    title="Modern Home Designs | Housekaar Construction in Patna"
    description="Explore modern home designs and construction services by Housekaar in Patna. Find inspiration for your dream modern house."
    keywords="modern home design, contemporary house, new home construction, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="URL_TO_MODERN_HOME_IMAGE"
    article={false}
   />
   <ModernFamilyHome />
  </>
 } />
 <Route path="/commercial-office" element={
  <>
   <Seo
    title="Commercial Office Building Construction | Housekaar Patna"
    description="Housekaar Construction in Patna offers expert commercial office building design and construction services. Build your ideal workspace."
    keywords="commercial office, office building design, office construction, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="URL_TO_COMMERCIAL_OFFICE_IMAGE"
    article={false}
   />
   <CommercialOfficeBuilding />
  </>
 } />
 <Route path="/historical-house" element={
  <>
   <Seo
    title="Historical House Renovation | Housekaar Construction Patna"
    description="Renovate your historical house with Housekaar Construction in Patna. We specialize in preserving and modernizing heritage homes."
    keywords="historical house renovation, heritage home restoration, old house remodeling, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="URL_TO_HISTORICAL_HOUSE_IMAGE"
    article={false}
   />
   <RenovatedHistoricalHouse />
  </>
 } />
 <Route path="/luxury-apartments" element={
  <>
   <Seo
    title="Luxury Apartment Complex Construction | Housekaar Patna"
    description="Build high-end luxury apartment complexes in Patna with Housekaar Construction. Quality design and construction guaranteed."
    keywords="luxury apartments, apartment complex construction, high-end residential, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="URL_TO_LUXURY_APARTMENTS_IMAGE"
    article={false}
   />
   <LuxuryApartmentComplex />
  </>
 } />
 <Route path="/ready-designs/cozy-family-home" element={
  <>
   <Seo
    title="Cozy Family Home Design | Ready Plans by Housekaar Patna"
    description="Explore our ready-made cozy family home design. Perfect for comfortable living in Patna, Bihar."
    keywords="cozy family home plan, small house design, ready house plan, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="URL_TO_COZY_FAMILY_HOME_IMAGE"
    article={true}
   />
   <CozyFamilyHomeDetails />
  </>
 } />
 <Route path="/ready-designs/modern-villa-details" element={
  <>
   <Seo
    title="Modern Villa Design Details | Housekaar Ready Plans Patna"
    description="View the details of our modern villa design. Get inspiration for your contemporary home in Patna."
    keywords="modern villa design, contemporary house plan, luxury home design, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="URL_TO_MODERN_VILLA_IMAGE"
    article={true}
   />
   <ModernVillaDetails />
  </>
 } />
 <Route path="/ready-designs/southfacinghousePlan" element={
  <>
   <Seo
    title="South Facing House Plan | Housekaar Ready Designs Patna"
    description="Discover our south-facing house plan, optimized for sunlight and ventilation in Patna, Bihar."
    keywords="south facing house plan, vastu compliant house, energy efficient design, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="URL_TO_SOUTH_FACING_HOUSE_IMAGE"
    article={true}
   />
   <SouthFacingHousePlan />
  </>
 } />
 <Route path="/ready-designs/houseplan20x30" element={
  <>
   <Seo
    title="20x30 House Plan | Ready Designs by Housekaar Patna"
    description="Explore our ready-made 20x30 house plan, ideal for compact urban living in Patna, Bihar."
    keywords="20x30 house plan, small plot design, compact home plan, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="URL_TO_HOUSE_PLAN_20X30_IMAGE"
    article={true}
   />
   <HousePlan20x30 />
  </>
 } />
 <Route path="/ready-designs/houseplan20x40" element={
  <>
   <Seo
    title="20x40 House Plan | Ready Designs by Housekaar Patna"
    description="View our ready-to-use 20x40 house plan, suitable for families in Patna, Bihar."
    keywords="20x40 house plan, rectangular plot design, family home plan, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="URL_TO_HOUSE_PLAN_20X40_IMAGE"
    article={true}
   />
   <HousePlan20x40 />
  </>
 } />
 <Route path="/ready-designs/houseplan30x40" element={
  <>
   <Seo
    title="30x40 House Plan | Ready Designs by Housekaar Patna"
    description="Explore our 30x40 house plan, offering a balanced living space in Patna, Bihar."
    keywords="30x40 house plan, medium size house plan, urban home design, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="URL_TO_HOUSE_PLAN_30X40_IMAGE"
    article={true}
   />
   <HousePlan30x40 />
  </>
 } />
 <Route path="/ready-designs/houseplan30x50" element={
  <>
   <Seo
    title="30x50 House Plan | Ready Designs by Housekaar Patna"
    description="Discover our spacious 30x50 house plan, perfect for comfortable living in Patna, Bihar."
    keywords="30x50 house plan, large home design, spacious house plan, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="URL_TO_HOUSE_PLAN_30X50_IMAGE"
    article={true}
   />
   <HousePlan30x50 />
  </>
 } />
 <Route path="/ready-designs/houseplan40x60" element={
  <>
   <Seo
    title="40x60 House Plan | Ready Designs by Housekaar Patna"
    description="View our expansive 40x60 house plan, ideal for a large family in Patna, Bihar."
    keywords="40x60 house plan, large plot design, luxury home plan, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="URL_TO_HOUSE_PLAN_40X60_IMAGE"
    article={true}
   />
   <HousePlan40x60 />
  </>
 } />
 <Route path="/floor-plans/2bhk-house-plans" element={
  <>
    <Seo
      title="2BHK House Plans & Designs in Bihar | Housekaar"
      description="Explore a variety of 2BHK house plans and designs suitable for families in Bihar. Find your dream 2 bedroom home layout at Housekaar."
      keywords="
      400 square feet floor plan,
      2bhk, 2 bhk house plan, 2bhk design, 2bhk flat, 2bhk floor plan, house plan 2bhk,2 BHK home naksha ,two bedroom home naksha, home plan 2bhk, flat 2bhk, 2 bedroom house plan, 2 bedroom flat, Patna, Gaya, Muzaffarpur, Darbhanga, Purnia, Bihar Sharif, Arrah, Hajipur, Sasaram, Katihar, Bodh Gaya, Siwan, Motihari, Begusarai, Buxar, Aurangabad, Nawada, north facing 2bhk house plan, east facing 2bhk house plan,small family house plan Patna 2 BHK,house plan with 2 bedrooms, west facing 2bhk house vastu plan, south facing 2bhk house vastu plan, 20x40 house plan 2bhk, 20x50 house plan 2bhk, 20x30 house plan 2bhk, 20x25 house plan 2bhk, 30x40 house plan 2bhk, 1000 sq ft 2bhk house plans, 1200 sq ft 2bhk house plan, 2bhk duplex house plan, 2bhk ground floor plan, 2bhk interior design, 2bhk room design, 2bhk elevation designs, 2bhk building plan, 2bhk plans with dimensions, 2bhk plans, cost of 2bhk flat, 2bhk flat price"
      location="Bihar, India"
      imageUrl="URL_TO_2BHK_HOUSE_PLAN_IMAGE"
      article={false}
    />
    <PageOne2BHK />
  </>
} />
        <Route path="/floor-plans/3bhk-house-plans" element={
  <>
    <Seo
      title="Explore 3BHK House Plans & Designs in Patna & Bihar | Housekaar"
      description="Discover a wide variety of 3BHK house plans, designs, and floor plans available in Patna and other cities across Bihar. Find spacious 3 bedroom home layouts."
      keywords="3bhk, 3 bhk house plan, 3bhk design, 3bhk flat, 3bhk floor plan, house plan 3bhk, home plan 3bhk, flat 3bhk, 3 bedroom house plan, 3 bedroom flat, Patna, Gaya, Muzaffarpur, Bhagalpur, Darbhanga, Purnia, Bihar Sharif, Arrah, Hajipur, Sasaram, Katihar, 30x50 house plan 3bhk, 30x40 house plan 3bhk, 3bhk duplex house plan,three bedroom home naksha,3 BHK home naksha ,comfortable home design Patna 3 bedroom,medium family house plan, 3bhk single floor house plan, east facing 3bhk house plan, north facing 3bhk house plan, west facing 3bhk house plan, 3bhk with car parking, 3bhk interior design, 3bhk room design, 1000 sq ft 3bhk house plans, 3bhk ground floor plan, 3bhk house price Patna, 3bhk house map Bihar, simple 3bhk house design Bihar, 20x40 house plan 3bhk Patna, 30x50 house plan 3bhk north facing Patna, 3bhk duplex flat Bihar, 3bhk house front design Bihar, 3bhk square feet Patna, 3bhk bungalow design Patna, 3bhk layout Patna, 3bhk plan layout Patna, 3bhk plan with dimensions Patna, 3bhk price Patna, best 3bhk house plan Bihar, what is 3bhk, 3bhk 2t, 3bhk 3t, interior cost for 3bhk Patna, 3bhk interior design package Patna, 3bhk interior design plan Patna, how much square feet required for 3bhk Patna, 3bhk cluster plan Bihar, 3bhk design plan Patna, 3bhk duplex house design Bihar, 3bhk flat design plan Patna, 3bhk house design Gaya, 3bhk floor plan Gaya, 3bhk house design Muzaffarpur, 3bhk floor plan Muzaffarpur, 3bhk house design Bhagalpur, 3bhk floor plan Bhagalpur, 3bhk house design Darbhanga, 3bhk floor plan Darbhanga, 3bhk house design Purnia, 3bhk floor plan Purnia, 3bhk house design Bihar Sharif, 3bhk floor plan Bihar Sharif, 3bhk house design Arrah, 3bhk floor plan Arrah, 3bhk house design Hajipur, 3bhk floor plan Hajipur, 3bhk house design Sasaram, 3bhk floor plan Sasaram, 3bhk house design Katihar, 3bhk floor plan Katihar"
      location="Patna, Bihar, India"
      imageUrl="URL_TO_GENERIC_3BHK_HOUSE_PLAN_IMAGE"
      article={false}
    />
    <PageTwo3BHK />
  </>
} />
        <Route path="/floor-plans/4bhk-house-plans" element={
  <>
    <Seo
      title="Discover Luxury 4BHK House Plans & Designs in Patna & Bihar | Housekaar"
      description="Explore a premium collection of 4BHK house plans, designs, and floor plans in Patna and across Bihar. Find spacious and luxurious 4 bedroom home layouts with modern amenities."
      keywords="4 bedroom home layout,
4 bedroom home blueprints,

      ,4bhk, 4 bhk house plan, 4bhk design, 4bhk flat, 4bhk floor plan, house plan 4bhk,four bedroom home naksha, home plan 4bhk, flat 4bhk,naksha 4 bedroom Patna,house plan with 4 bedrooms, 4 bedroom house plan, 4 bedroom flat, Patna, Gaya, Muzaffarpur, Bhagalpur, Darbhanga, Purnia, Bihar Sharif, Arrah, Hajipur, Sasaram, Katihar, 4bhk duplex, 4bhk bungalow, 4bhk with pooja room, 4bhk with vastu, 4bhk interior design, 4bhk flat design, 4bhk house plan pdf, 4bhk house plan in 1200 sq ft, 4bhk floor plan in 2000 sq ft, 4bhk flat map, 4bhk plan and elevation, interior design for 4bhk house Patna, 1200 sq ft 4bhk house plan Patna, 4bhk duplex house design Bihar, 4bhk flat floor plan Patna, 4bhk flat layout Patna, 4bhk house plan design Bihar, 4bhk luxury house plan Patna, 4bhk plan with vastu Patna, 4bhk bungalow Patna, 4bhk bungalow plan Patna, 4bhk duplex floor plan Patna, 4bhk duplex house Bihar, 4bhk duplex plan Patna, 4bhk flat interior Patna, 4bhk flat interior design Patna, 4bhk floor plan in 1200 sq ft Patna, 4bhk floor plan in 1500 sq ft Patna, 4bhk house cost Patna, 4bhk house map Bihar, 4bhk house photo Bihar, 4bhk house plan map Bihar, 4bhk house design Gaya, 4bhk floor plan Gaya, 4bhk house design Muzaffarpur, 4bhk floor plan Muzaffarpur, 4bhk house design Bhagalpur, 4bhk floor plan Bhagalpur, 4bhk house design Darbhanga, 4bhk floor plan Darbhanga, 4bhk house design Purnia, 4bhk floor plan Purnia, 4bhk house design Bihar Sharif, 4bhk floor plan Bihar Sharif, 4bhk house design Arrah, 4bhk floor plan Arrah, 4bhk house design Hajipur, 4bhk floor plan Hajipur, 4bhk house design Sasaram, 4bhk floor plan Sasaram, 4bhk house design Katihar, 4bhk floor plan Katihar, 4bhk Patna price, 4bhk house means, 4bhk 4t means"
      location="Patna, Bihar, India"
      imageUrl="URL_TO_GENERIC_4BHK_HOUSE_PLAN_IMAGE"
      article={false}
    />
    <PageThree4BHK />
  </>
} />
<Route path="/floor-plans/3d-home-plans" element={
  <>
    <Seo
      title="Visualize Your Patna Home in Stunning 3D: Detailed House Plans"
      description="Explore our immersive 3D house plans designed for Patna, Bihar. Get a realistic preview of layouts and designs to help you build your dream home."
      keywords="
      3d floorplan,
      3D house plan Patna, home design 3D Patna Bihar, visualize home layout Patna, floor plan 3D Bihar, modern house design Patna, home naksha 3d, home naksha design 3d, design home naksha, digital home naksha"
      location="Patna, Bihar, India"
      imageUrl="URL_TO_A_RELEVANT_IMAGE_FOR_3D_PLANS" // Replace with an actual image URL
      article={false}
    />
    <PageHomeNaksha3D />
  </>
} />

<Route path="/floor-plans/village-homes" element={
  <>
    <Seo
      title="Traditional Village House Plans in Patna: Authentic Bihar Designs"
      description="Discover our collection of charming and culturally-rooted village home plans perfect for Patna and the rural areas of Bihar. Embrace traditional architecture."
      keywords="village house design,
village house,
simple village house design,
village house front design images,
village house design photo,
indian village house plan,
modern village house design,
village house design in india,
village house planning,villagehouseplan,
simple village house colour,
village house portico design,
village house railing design,
village house images,
simple village house design photo,
simple village house design in india,
village house pics,
village house front elevation design,
village house front design indian style,
old village house,
village house painting colours outside,
village house pictures,
drawing village house,
village home design simple,
small village house design,
village house in india,
village house photo,
village house front design,
house village,
beautiful village house,
village house colour outside,
village style house design,
village house balcony design,
old village house design,
village house colour design outside,
village house railing design photos,
6 room house plan in village,
village house tour,
village house images gallery,
30 40 house plans for 1200 sq ft house plans,
village house chota ghar ka design,
simple village house front design in india,
village home naksha, village home plan Patna, traditional house design Bihar, rural home design Patna, east facing home naksha Bihar, desi home naksha Patna, home naksha for village, home naksha front, beautiful home naksha"
      location="Patna, Bihar, India"
      imageUrl="URL_TO_A_RELEVANT_IMAGE_FOR_VILLAGE_HOMES" // Replace with an actual image URL
      article={false}
    />
    <PageVillageHomeNaksha />
  </>
} />

<Route path="/floor-plans/simple-homes" element={
  <>
    <Seo
      title="Simple & Affordable House Plans in Patna: Practical Home Designs"
      description="Browse our range of straightforward and budget-friendly house plans for Patna, Bihar. Ideal for first-time buyers and those seeking easy living."
      keywords="simple home naksha, simple home plan Patna, affordable home design Bihar, budget home Patna, small home naksha, chota home naksha Patna, home naksha photo, home naksha design, home naksha drawing, design home naksha"
      location="Patna, Bihar, India"
      imageUrl="URL_TO_A_RELEVANT_IMAGE_FOR_SIMPLE_HOMES" // Replace with an actual image URL
      article={false}
    />
    <PageSimpleHomeNaksha />
  </>
} />

<Route path="/floor-plans/vastu-homes" element={
  <>
    <Seo
      title="Vastu Shastra House Plans in Patna: Harmonious & Auspicious Homes"
      description="Explore Vastu compliant house plans for your home in Patna, Bihar, designed to promote positive energy and well-being. Consult our Vastu experts."
      keywords="vastu house plan Patna, vastu shastra home Bihar, home map according to vastu Patna, home map as per vastu shastra Bihar, vastu home design Patna, home map architect, east facing home naksha, home naksha front, home naksha design"
      location="Patna, Bihar, India"
      imageUrl="URL_TO_A_RELEVANT_IMAGE_FOR_VASTU_HOMES" // Replace with an actual image URL
      article={false}
    />
    <PageVastuHomeNaksha />
  </>
} />
<Route path="/floor-plans/mappass" element={
  <>
    <Seo
      title="Patna House Plan Approval Guide: Your Step-by-Step MapPass"
      description="Navigate the Patna house plan approval process with our easy MapPass guide. Understand where to submit, required documents, and building rules in Patna, Bihar."
      keywords="house plan approval Patna, building permit Patna, naksha pass Bihar, home plan sanction Patna, PMC house plan, PMAA building approval, BDO house permission Patna, Bihar building bylaws, MapPass Patna"
      location="Patna, Bihar, India"
      imageUrl="URL_TO_A_RELEVANT_IMAGE_FOR_MAP_PASS_GUIDE" // Replace with an actual image URL
      article={true} // Assuming this is a guide/article
    />
    <MapPass />
  </>
} />
        <Route path="/floor-plans/shop-commercial-plans-bihar" element={<PageShopsBihar />} />
        <Route path="/floor-plans/office-space-plans-bihar" element={<PageOfficesBihar />} />
        <Route path="/floor-plans/other-building-types-bihar" element={<PageOtherBuildingsBihar />} />
          <Route
            path="/privacy-policy"
            element={
              <>
                <Seo
                  title="Privacy Policy | Housekaar Construction in Patna"
                  description="Read our privacy policy to understand how Housekaar Construction in Patna collects, uses, and protects your personal information. We respect your privacy."
                  keywords="privacy policy, data protection, user privacy, Patna, Bihar, Housekaar, website privacy, information security"
                  location="Patna, Bihar"
                  imageUrl="URL_TO_PRIVACY_POLICY_IMAGE"
                  article={false}
                />
                <PrivacyPolicy />
              </>
            }
          />
          <Route
            path="/terms-of-service"
            element={
              <>
                <Seo
                  title="Terms of Service | Housekaar Construction in Patna"
                  description="Review our terms of service for using Housekaar Construction's website and services in Patna. Understand your rights and responsibilities."
                  keywords="terms of service, website terms, service agreement, Patna, Bihar, Housekaar, user agreement, legal terms"
                  location="Patna, Bihar"
                  imageUrl="URL_TO_TERMS_OF_SERVICE_IMAGE"
                  article={false}
                />
                <TermsOfService />
              </>
            }
          />
          <Route
            path="/cookie-policy"
            element={
              <>
                <Seo
                  title="Cookie Policy | Housekaar Construction in Patna"
                  description="Our cookie policy explains how we use cookies to enhance your browsing experience, analyze site traffic, and personalize content. Understand your choices and manage your settings on Housekaar's website in Patna."
                  keywords="cookie policy, cookies, website cookies, privacy, data protection, GDPR, CCPA, cookie management, Patna, Bihar, Housekaar"
                  location="Patna, Bihar"
                  imageUrl="URL_TO_COOKIE_POLICY_IMAGE"
                  article={false}
                />
                <CookiePolicy />
              </>
            }
          />
          <Route path="/blog/understanding-elevation-in-construction" element={
  <>
   <Seo
    title="Understanding Elevation in Construction | Housekaar Blogs Patna"
    description="Learn about elevation in construction, its importance, and key considerations from Housekaar Construction in Patna."
    keywords="elevation in construction, building elevation, construction terms, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="https://housekaar.com/static/media/elevation_img_17.1d5c85337937f6f44670.avif"
    article={true}
   />
   <ElevationBlogPage />
  </>
 } />
 <Route path="/blog/modern-home-design-2024" element={
  <>
   <Seo
    title="Modern Home Design Trends 2024 | Housekaar Blogs Patna"
    description="Explore the latest modern home design trends for 2024 with insights from Housekaar Construction in Patna."
    keywords="modern home design 2024, contemporary house trends, new home styles, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="https://housekaar.com/static/media/hall_img_1.7be303ad57ca2b4910b9.avif"
    article={true}
   />
   <ModernHomeDesignPage />
  </>
 } />
 <Route path="/blog/cost-effective-interior-design" element={
  <>
   <Seo
    title="Cost-Effective Interior Design Tips | Housekaar Blogs Patna"
    description="Discover budget-friendly interior design tips and ideas from Housekaar Construction in Patna."
    keywords="cost effective interior design, affordable home decor, budget interior design, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="URL_TO_COST_EFFECTIVE_INTERIOR_DESIGN_BLOG_IMAGE"
    article={true}
   />
   <CostEffectiveInteriorDesignPage />
  </>
 } />
 <Route path="/blog/sustainable-construction-patna" element={
  <>
   <Seo
    title="Sustainable Construction in Patna | Housekaar Blogs"
    description="Learn about sustainable construction practices and their importance in Patna, Bihar, from Housekaar Construction."
    keywords="sustainable construction, green building, eco-friendly construction, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="https://housekaar.com/static/media/living_room_img_3.11d12e675fcaf997bc5d.avif"
    article={true}
   />
   <SustainableConstructionPatnaPage />
  </>
 } />
 <Route path="/blog/smart-kitchen-design" element={
  <>
   <Seo
    title="Smart Kitchen Design Ideas | Housekaar Blogs Patna"
    description="Explore innovative smart kitchen design ideas and technologies with Housekaar Construction in Patna."
    keywords="smart kitchen design, modern kitchen technology, innovative kitchen ideas, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="https://housekaar.com/static/media/kitchen_img_3.4e9d1fa9848f03c52ebd.avif"
    article={true}
   />
   <SmartKitchenDesignPage />
  </>
 } />
 <Route path="/blog/blue-print-symbols-guide" element={
  <>
   <Seo
    title="Blueprint Symbols Guide | Housekaar Blogs Patna"
    description="A comprehensive guide to understanding common blueprint symbols used in construction, from Housekaar in Patna."
    keywords="blueprint symbols, construction drawings, architectural symbols, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="https://housekaar.com/static/media/blueprint-4056027_1920.a887a90ea06ddc530faa.avif"
    article={true}
   />
   <BlueprintSymbolsGuidePage />
  </>
 } />
 <Route path="/blog/bihar-me-ghar-banane-ki-lagat" element={
  <>
   <Seo
    title="Bihar Mein Ghar Banane Ki Lagat (Construction Cost in Bihar) | Housekaar Blogs"
    description="जानें बिहार में घर बनाने की लागत कितनी आती है | Housekaar Construction, पटना से नवीनतम जानकारी।"
    keywords="बिहार में घर बनाने की लागत, construction cost in Bihar, ghar banane ka kharcha, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="https://housekaar.com/static/media/elevation_img_21.07de9e9b288a0727a323.avif"
    article={true}
   />
   <GharBananeKiLagatBiharPage />
  </>
 } />
 <Route path="/blog/chote-gharon-ke-liye-behtareen-design" element={
  <>
   <Seo
    title="छोटे घरों के लिए बेहतरीन डिज़ाइन | Housekaar Blogs Patna"
    description="छोटे घरों के लिए बेहतरीन और आधुनिक डिज़ाइन के बारे में जानें | Housekaar Construction, पटना से सुझाव।"
    keywords="छोटे घरों के लिए डिज़ाइन, small house design, compact home design, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="https://housekaar.com/static/media/elevation_img_7.d26e4feed5e59e24d134.avif"
    article={true}
   />
   <ChoteGharonKeLiyeBehtareenDesignPage />
  </>
 } />
 <Route path="/blog/apni-nayi-ghar-ki-yojana-kaise-banaye" element={
  <>
   <Seo
    title="अपनी नई घर की योजना कैसे बनाएं | Housekaar Blogs Patna"
    description="अपनी नई घर की योजना बनाने के लिए महत्वपूर्ण कदम और सुझाव | Housekaar Construction, पटना से मार्गदर्शन।"
    keywords="घर की योजना कैसे बनाएं, new home plan, house planning guide, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="https://housekaar.com/static/media/floor_plan_5.8220490cd6ead08ab71e.avif"
    article={true}
   />
   <ApniNayiGharKiYojanaKaiseBanayePage />
  </>
 } />
 <Route path="/blog/vastu-shastra-ke-ghar-ka-design" element={
  <>
   <Seo
    title="वास्तु शास्त्र के अनुसार घर का डिज़ाइन | Housekaar Blogs Patna"
    description="वास्तु शास्त्र के अनुसार घर का डिज़ाइन कैसा होना चाहिए | Housekaar Construction, पटना से वास्तु टिप्स।"
    keywords="वास्तु शास्त्र घर का डिज़ाइन, vastu shastra house design, Indian home design, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="https://housekaar.com/static/media/room_img_3.2d0f3eebdde62ea219a4.avif"
    article={true}
   />
   <VastuShastraKeAnusarGharKaDesignPage />
  </>
 } />
 <Route path="/blog/mazboot-ghar-banane-ke-liye-mahatvapurna-batein" element={
  <>
   <Seo
    title="मज़बूत घर बनाने के लिए महत्वपूर्ण बातें | Housekaar Blogs Patna"
    description="एक मज़बूत और टिकाऊ घर बनाने के लिए महत्वपूर्ण बातें | Housekaar Construction, पटना से विशेषज्ञ सलाह।"
    keywords="मज़बूत घर, durable house construction, strong home building, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="https://housekaar.com/static/media/elevation_img_29.a861d681607dcdffe92a.avif"
    article={true}
   />
   <MazbootGharBananeKeLiyeMahatvapurnaBateinPage />
  </>
 } />
 <Route path="/blog/ghar-ke-nakshe-ko-kaise-samjhe" element={
  <>
   <Seo
    title="घर के नक्शे को कैसे समझें | Housekaar Blogs Patna"
    description="घर के नक्शे को आसानी से समझने के लिए गाइड | Housekaar Construction, पटना से नक्शा पढ़ने का तरीका।"
    keywords="घर का नक्शा, house plan reading, blueprint understanding, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="https://housekaar.com/static/media/blueprint-4056027_1920.a887a90ea06ddc530faa.avif"
    article={true}
   />
   <GharKeNaksheKoKaiseSamjhePage />
  </>
 } />
 <Route path="/blog/3d-blender" element={
  <>
   <Seo
    title="3D Interior Design Process with Blender | Housekaar Blogs Patna"
    description="Learn about the 3D interior design process using Blender with insights from Housekaar Construction in Patna."
    keywords="3D interior design, Blender tutorial, interior design software, Patna, Bihar, Housekaar"
    location="Patna, Bihar"
    imageUrl="https://housekaar.com/static/media/dinning_area.ef0eab7876b197ac8153.webp"
    article={true}
   />
   <ThreeDInteriorDesignProcessPage />
  </>
 } />
 <Route path="/blog/houseplanguide" element={
  <>
    <Seo
      title="Unlock Your Dream Home: The Importance of House Plans in Patna"
      description="Planning to build in Patna, Bihar? Discover why a detailed house plan is essential for a successful and stress-free construction journey. Learn more!"
      keywords="house plan, floor plan, building plan Patna, home design Patna, architect Patna, construction guide Patna"
      location="Patna, Bihar"
      imageUrl="https://housekaar.com/static/media/floor_plan_6.495d28c04e898e7f2b7c.avif" 
      article={true}
    />
    <HousePlanImportancePage />
  </>
} />
<Route path="/blog/freehouseplanguide" element={
  <>
    <Seo
      title="Free House Plans in Patna: Find Your Affordable Home Design"
      description="Discover a variety of free house plans and designs online in Patna, Bihar. Start building your dream home without breaking the bank!"
      keywords="free home naksha, free house plan, affordable home design Patna, low-cost house plan Bihar,3 bhk home naksha , free floor plan, budget home design, home naksha online, home naksha design online free"
      location="Patna, Bihar"
      imageUrl="URL_TO_A_RELEVANT_IMAGE_FOR_FREE_PLANS" // Replace with an actual image URL
      article={false} // Adjust if the page content is structured as an article
    />
    <FreeHousePlanPage />
  </>
} />
<Route path='blog/new-house-construction' element={
  <>
    <Seo
      title="The Ultimate New Home Construction Checklist: From Dream to Keys"
      description="Building your dream home can be overwhelming. This ultimate checklist guides you through every step, from initial planning to moving in."
      keywords="new home construction, home building checklist, dream home, construction process, house planning, Patna, Bihar, India" // Added location keywords
      location="Patna, Bihar, India"  // Explicitly set location
      imageUrl="URL_TO_A_RELEVANT_IMAGE_FOR_NEW_CONSTRUCTION" // You MUST replace this with a relevant URL
      article={true}
      publishedTime="2025-04-30" // Make sure this matches your post
      modifiedTime="2025-04-30"    // Make sure this matches your post
      author="Housekaar" // Keep author
    />
    <NewHomeConstructionChecklistPage/>
  </>
}/>
<Route path='/blog/avoiding-mistakes' element={
  <>
    <Seo
      title="Avoiding the Top 5 Mistakes New Home Builders Make"
      description="Embarking on building your dream home? Learn from the experiences of others and avoid these top 5 common mistakes new home builders often make."
      keywords="new home construction mistakes, home building errors, avoid construction pitfalls, house building tips, new home advice, Patna, Bihar, India"
      location="Patna, Bihar, India"
      imageUrl="URL_TO_A_RELEVANT_IMAGE_FOR_MISTAKES"  //  Replace with actual URL
      article={true}
      publishedTime="2025-05-20"
      modifiedTime="2025-05-20"
      author="Housekaar"
    />
    <AvoidingTop5MistakesPage />
  </>
}/>
<Route path='/blog/small-office-design' element={
  <>
    <Seo
      title="Beyond the Cubicle: How to Design a Small Office Space That Inspires Productivity"
      description="Feeling cramped in your small office? Discover smart furniture, clever layouts, and design hacks to transform any tiny workspace into a highly productive and inspiring environment."
      keywords="Small Office Design,Home Office Ideas,Office Space Optimization,Productivity Hacks,Tiny Office Solutions,Ergonomic Office,Work From Home Setup,Compact Office Furniture,Office Lighting,Office Organization,Small Space Decor,	Interior Design Tips, Productive Workspace,	Modern Office Design,	Budget Office Ideas, Patna, Bihar, India"
      location="Patna, Bihar, India"
      imageUrl="URL_TO_A_RELEVANT_IMAGE_FOR_MISTAKES"  //  Replace with actual URL
      article={true}
      publishedTime="2025-05-20"
      modifiedTime="2025-05-20"
      author="Housekaar"
    />
    <SmallOfficeDesignPage />
  </>
}/>
<Route path='/blog/vastuhome' element={
  <>
    <Seo
      title="Vastu-Compliant House Plans for Your Dream Home in Bihar: Everything You Need to Know"
      description="Unlock positive energy and harmony in your Bihar home with Vastu-compliant house plans. Learn essential principles for plot selection, room placement, and more to build your dream home."
      keywords="'Vastu', 'Vastu Shastra', 'Bihar house plans', 'Vastu compliant homes', 'home design', 'architecture', 'Indian architecture', 'Patna', 'Bhagalpur' , Bihar, India"
      location="Patna, Bihar, India"
      imageUrl="URL_TO_A_RELEVANT_IMAGE_FOR_MISTAKES"  //  Replace with actual URL
      article={true}
      publishedTime="2025-05-22"
      modifiedTime="2025-05-23"
      author="Housekaar"
    />
    <VastuCompliantHouse/>
    </>
}/>

<Route
  path="/blog/vastu-compliant-house-plans-bihar"
  element={
    <>
      <Seo
        title="Vastu-Compliant House Plans for Your Dream Home in Bihar: Everything You Need to Know"
        description="Unlock positive energy and harmony in your Bihar home with Vastu-compliant house plans. Learn essential principles for plot selection, room placement, and more to build your dream home."
        keywords="Vastu, Vastu Shastra, Bihar house plans, Vastu compliant homes, home design, architecture, Indian architecture, Patna, Bhagalpur, Bihar, India"
        location="Patna, Bihar, India"
        imageUrl="/path/to/vastu-house-plans-image.webp" // Replace with actual relevant image URL
        article={true}
        publishedTime="2025-05-22"
        modifiedTime="2025-05-23"
        author="Housekaar"
      />
      <VastuCompliantHouse />
    </>
  }
/>
<Route
  path="/blog/top-5-vastu-tips-prosperous-kitchen-bihar"
  element={
    <>
      <Seo
        title="Top 5 Vastu Tips for a Prosperous Kitchen in Bihar"
        description="Discover essential Vastu Shastra tips to design a kitchen that invites prosperity, good health, and positive energy into your Bihar home. Learn about ideal directions and placements."
        keywords="Vastu kitchen tips, prosperous kitchen, Vastu for kitchen, Bihar kitchen design, Vastu Shastra, home remedies Vastu, kitchen layout, Indian kitchen, Patna, Bihar, India"
        location="Patna, Bihar, India"
        imageUrl="/path/to/vastu-kitchen-image.webp" // Replace with actual relevant image URL
        article={true}
        publishedTime="2025-05-20" // Example date
        modifiedTime="2025-05-21" // Example date
        author="Housekaar"
      />
      <VastuKitchenTips />
    </>
  }
/>
<Route
  path="/blog/choosing-right-direction-main-entrance-vastu-bihar"
  element={
    <>
      <Seo
        title="Choosing the Right Direction for Your Main Entrance as per Vastu in Bihar"
        description="Understand the critical importance of the main entrance in Vastu Shastra for your Bihar home. Learn the ideal directions to invite positive energy, wealth, and happiness."
        keywords="Vastu main entrance, main door Vastu, Vastu entrance direction, Bihar home entrance, Vastu Shastra, home design, positive energy home, Indian architecture, Patna, Bihar, India"
        location="Patna, Bihar, India"
        imageUrl="/path/to/vastu-main-entrance-image.webp" // Replace with actual relevant image URL
        article={true}
        publishedTime="2025-05-18" // Example date
        modifiedTime="2025-05-19" // Example date
        author="Housekaar"
      />
      <VastuMainEntrance />
    </>
  }
/>
<Route
  path="/blog/integrating-traditional-bihari-architecture-modern-vastu"
  element={
    <>
      <Seo
        title="Integrating Traditional Bihari Architecture with Modern Vastu Principles"
        description="Explore how to blend the rich heritage of traditional Bihari architecture with contemporary Vastu Shastra principles to create a unique, harmonious, and energy-efficient home in Bihar."
        keywords="Bihari architecture, traditional Indian architecture, modern Vastu, Vastu principles, Bihar home design, sustainable architecture, cultural design, traditional house plans, Patna, Bihar, India"
        location="Patna, Bihar, India"
        imageUrl="/path/to/bihari-architecture-vastu-image.webp" // Replace with actual relevant image URL
        article={true}
        publishedTime="2025-05-15" // Example date
        modifiedTime="2025-05-16" // Example date
        author="Housekaar"
      />
      <BihariArchitectureVastu />
    </>
  }
/>
<Route
  path="/blog/multi-storey-house-plans-bihar"
  element={
    <>
      <Seo
        title="Multi-Storey House Plans in Bihar: Design Considerations and Benefits"
        description="Planning a multi-storey home in Bihar? Discover the benefits, design considerations, and popular trends for multi-level house plans that maximize space and functionality for growing families."
        keywords="multi-storey house plans, two-storey house design, Bihar house plans, vertical living, space optimization, modern house plans, family homes Bihar, residential architecture, Patna, Bihar, India"
        location="Patna, Bihar, India"
        imageUrl="/path/to/multi-storey-house-image.webp" // Replace with actual relevant image URL
        article={true}
        publishedTime="2025-05-10" // Example date
        modifiedTime="2025-05-11" // Example date
        author="Housekaar"
      />
      <MultiStoreyHousePlans />
    </>
  }
/>

<Route
  path="/blog/interior-design"
  element={
    <>
      <Seo
        title="Beyond the Walls: Crafting Spaces that Inspire – Office & Room Interior Design"
        description="Discover how thoughtful interior design can transform your office and home into environments that boost productivity, promote well-being, and reflect your unique style. Learn key principles for creating inspiring spaces."
        keywords="interior design, office design, room design, home decor, workspace design, productivity, well-being, design tips, modern design, inspiration, Patna, Bihar, India"
        location="Patna, Bihar, India"
        imageUrl="/path/to/interior-design-featured-image.webp" // Replace with actual relevant image URL
        article={true}
        publishedTime="2025-05-24"
        modifiedTime="2025-05-24"
        author="Housekaar"
      />
      <DesignInspirationBlog/>
    </>
  }
/>

<Route
  path="/blog/constructionchallenges"
  element={
    <>
      <Seo
        title="Building Dreams, Avoiding Nightmares: Common Construction Challenges – Housekaar"
        description="Discover common pitfalls in house construction projects in Patna, from budget overruns to unexpected delays, and learn practical strategies to overcome them successfully. Get expert tips from Housekaar."
        keywords="construction challenges, home building, renovation mistakes, construction budget, project delays, quality control, Patna construction, housekaar"
        location="Patna, Bihar, India"
        imageUrl="/img/kitchen_8.avif" // Use the image from your blog component
        article={true}
        publishedTime="2025-06-03T10:00:00+05:30" // Use the date from your blog component
        modifiedTime="2025-06-03T10:00:00+05:30" // Use the date from your blog component
        author="Housekaar"
      />
      <ConstructionChallengesPage/>
    </>
  }
/>

<Route
  path="/blog/Kitcheninteriordesign"
  element={
    <>
      <Seo
        title="Designing Your Dream Kitchen: Style & Functionality in Patna – Housekaar"
        description="Explore the latest trends and essential tips for creating a beautiful and highly functional kitchen interior in Patna, from modular designs to smart storage solutions with Housekaar."
        keywords="kitchen design, interior design Patna, modular kitchen, kitchen trends, smart kitchen, storage solutions, Patna home design, Housekaar"
        location="Patna, Bihar, India"
        imageUrl="/img/kitchen_7.avif" // Use the image from your blog component
        article={true}
        publishedTime="2025-06-03T05:40:00+05:30" // Use the date from your blog component
        modifiedTime="2025-06-03T05:40:00+05:30" // Use the date from your blog component
        author="Housekaar"
      />
      <KitchenInteriorDesignPage/>
    </>
  }
/>
 <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
    </>
  );
};

export default App;